import { ADMIN_ROLES } from '@/core/constants/allowed-roles.constant'

// Roles allowed to view and manage the Users & Access section (SP-692).
export const USERS_ACCESS_ROLES = [...ADMIN_ROLES, 'sps-admin']

// Roles allowed to delete SPS projects (administrators and SPS admins).
export const DELETE_PROJECT_ROLES = [...ADMIN_ROLES, 'sps-admin']

// Roles allowed to create SPS projects (administrators and SPS admins).
export const CREATE_PROJECT_ROLES = [...ADMIN_ROLES, 'sps-admin']

// Roles allowed to manage a project from the actions menu (edit, delete, close,
// status report and exports). Consultants and reviewers only keep the culture
// report and share survey actions.
export const MANAGE_PROJECT_ROLES = [...ADMIN_ROLES, 'sps-admin']

// Maps the SPS role identifier returned by the backend to the normalized key
// used to group and label users on the Users & Access page.
export const USERS_ACCESS_ROLE_KEYS = {
  'sps-admin': 'admin',
  'sps-consultant': 'consultant',
  'sps-reviewer': 'reviewer',
}

// Order in which role groups are rendered (priority admin > consultant > reviewer).
export const USERS_ACCESS_ROLE_ORDER = ['admin', 'consultant', 'reviewer']

// Fallback group key for users whose role does not match a known SPS role.
export const USERS_ACCESS_ROLE_FALLBACK = 'other'

// Locales the backend can actually build a survey template for. The default
// language is validated against this list on save, so the picker never offers a
// language the API would reject. `buildLanguagesList` is wider on purpose: a
// project can be translated into any of those, it just cannot open in one.
// Mirrors SUPPORTED_LOCALES in the API (sps/services/projects/templates/
// default-survey/i18n); keep both in sync.
export const SUPPORTED_DEFAULT_LOCALES = [
  'af',
  'ar',
  'bn',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'es-419',
  'fi',
  'fr',
  'fr-CA',
  'gu',
  'he',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'kn',
  'ko',
  'lt',
  'mr',
  'ms',
  'nl',
  'no',
  'pl',
  'pt-BR',
  'pt-PT',
  'ro',
  'ru',
  'sr',
  'sv',
  'ta',
  'te',
  'tr',
  'uk',
  'ur',
  'zh-Hans',
  'zh-Hant',
  'zu',
]
